__turbopack_context__.v({
  "borderless": "Gdq1wG_borderless",
  "controlButtonElement": "Gdq1wG_controlButtonElement",
  "controlButtons": "Gdq1wG_controlButtons",
  "root": "Gdq1wG_root",
  "secondaryButtons": "Gdq1wG_secondaryButtons",
  "seekbar": "Gdq1wG_seekbar",
  "small-btn": "Gdq1wG_small-btn",
});
